import React from "react";
import {FormattedMessage} from 'react-intl';

import {findMobileOperatingSystem, onUseAppInsteadOfWeb} from "../../util/common";
import safariImg from "../../assets/img/safari.png";
import chromeImg from "../../assets/img/chrome.png";
import zonizLogo from "../../assets/img/logo_small.png";

function OpenAppInBanner(props) {
    const operatingSystem = findMobileOperatingSystem();
    return (
        <>
            <div className={props.continueInBrowser ? "blurry-background hidden" : "blurry-background"}></div>
            <div className={props.continueInBrowser ? "banner open-app-in hidden" : "banner open-app-in"} data-qa="open-app-in-banner">
                <div className="row title">
                    <p><FormattedMessage id="StartOrderingIn"/></p>
                </div>
                <div className="row option-row">
                    <div className="col">
                        <img src={zonizLogo} alt="zoniz logo" className="logo"/>
                        <p><FormattedMessage id="ZonizApp"/></p>
                    </div>
                    <div className="col">
                        <a onClick={() => onUseAppInsteadOfWeb()}
                           data-qa="open-in-app-banner-get-app"
                           className="btn btn-md  btn-default"><FormattedMessage id="GetApp"/></a>
                    </div>
                </div>
                <div className="row option-row">
                    <div className="col">
                        {
                            operatingSystem === "ios" ?
                                <img alt="safari" src={safariImg} alt="" className="safari logo"/>
                                : <img alt="chrome" src={chromeImg} alt="" className="chrome logo"/>
                        }

                        <p><FormattedMessage id="Browser"/></p>
                    </div>
                    <div className="col">
                        <a onClick={props.onContinueInBrowserClick}
                           data-qa="open-in-app-banner-cont-btn"
                           className="btn btn-md btn-outlined"><FormattedMessage id="Continue"/></a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OpenAppInBanner;
